import { getMaxMediaLimitsHintForMessengers } from "../utils/messengerMediaLimits";

export default function MaxVideoLimitHint({ availableMessengers, className = "" }) {
  const text = getMaxMediaLimitsHintForMessengers(availableMessengers);
  if (!text) {
    return null;
  }

  return (
    <p className={`app-messenger-media-hint${className ? ` ${className}` : ""}`}>
      {text}
    </p>
  );
}
